export default __webpack_public_path__ + "static/media/mongodb.805f88f7.svg";